<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        class="scrollList"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadList"
      >
        <div v-for="item in list" :key="item.UserID" class="xy-list searchs-flex">
          <div class="searchs nowrap">
            <div class="search-name nowrap">{{ item.Name }}</div>
            <div class="search-mark nowrap">{{ item.UserName }}</div>
            <div class="search-mark nowrap">学分：{{ item.Score }}</div>
          </div>
          <div>
            <button class="xy-public-btn" @click="details(item.UserID)">详情</button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "searchList",
  data() {
    return {
      rowData: {},
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      pageSize: 15,
      list: []
    };
  },
  created() {
    this.rowData = this.$store.state.evaluation.organizationId;
  },
  mounted() {},
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.list = [];
        this.isLoading = false;
        this.loadList();
      }, 500);
    },
    async loadList() {
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/ProjectStudentScore/GetClassCore?id=${this.rowData.studentOrganizationId}`
      );
      if (res.success) {
        let _list = res.data;
        this.list = _list;
        this.loading = false;
        this.finished = this.list.length === _list.length ? true : false;
      }
    },
    // 点击查看
    details: function(userId) {
      this.$store.commit("evaluation/getStudentId", {
        StudentID: userId
      });
      this.$router.push("/home/synthesizeQuality/ScoreDetails");
    }
  }
};
</script>

<style lang="less" scoped>
.xy-list {
  background: #ffffff;
  height: 150px;
  margin: 18px;
  border-radius: 12px;
  padding: 0 18px;
}
.searchs-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .searchs {
    flex: 1;
    padding-right: 80px;
    .cut-line {
      color: #ccc;
      padding: 0 10px;
    }
    .search-mark {
      font-size: 24px;
      color: #7f7f7f;
      margin-top: 14px;
    }
    .search-name {
      font-size: 28px;
      font-weight: 600;
    }
  }
  .search-mark-name {
    font-size: 24px;
    color: #cccccc;
    text-align: center;
    margin-top: 8px;
  }
}
</style>